import React, { Component, RefObject, WheelEvent } from 'react';
import classNames from 'classnames';
import AvatarEditor, { AvatarEditorProps } from 'react-avatar-editor';
import { observer } from 'mobx-react';
import { action, observable } from 'mobx';

import style from './ImageEditor.module.scss';

const SCALE_MIN = 1;
const SCALE_MAX = 2;
const SCALE_STEP = 0.1;

export type ImageEditorRef = AvatarEditor;

interface IProps extends AvatarEditorProps {
  editorRef?: RefObject<ImageEditorRef>;
  scaleStep?: number;
  onChange?: () => void;
}

@observer
class ImageEditor extends Component<IProps> {
  @observable private _scale = 1;

  render() {
    const { className, editorRef, onMouseUp, ...props } = this.props;

    return (
      <div
        className={classNames(style.editor, className)}
        onWheel={this._handleWheel}
      >
        <AvatarEditor
          {...props}
          ref={editorRef}
          scale={this._scale}
          onMouseUp={() => {
            onMouseUp?.();
            this.props.onChange?.();
          }}
        />
      </div>
    );
  }

  private _handleWheel = (event: WheelEvent) => {
    const isDown = event.deltaY > 0;

    if (isDown) {
      this._onScaleDecrease();
    } else {
      this._onScaleIncrease();
    }
  };

  @action
  private _onScaleIncrease = () => {
    const scaleStep = this.props.scaleStep ?? SCALE_STEP;

    const newScale = this._scale + scaleStep;
    if (newScale > SCALE_MAX) return;

    this._scale = newScale;
    this.props.onChange?.();
  };

  @action
  private _onScaleDecrease = () => {
    const scaleStep = this.props.scaleStep ?? SCALE_STEP;

    const newScale = this._scale - scaleStep;
    if (newScale < SCALE_MIN) return;

    this._scale = newScale;
    this.props.onChange?.();
  };
}

export { ImageEditor };
